import React,  { useEffect } from "react";
import { TextField, DialogContent, Dialog, Typography, Button, CircularProgress } from "@material-ui/core";
import useStyles from "../styles";
import { checkDocument, setDocumentStatus } from "../api";

const RejectDialog = ({handleState, hash}) => {
    const [state, setState] = handleState;
    const cl = useStyles()

    const handleClose = () => {
        setState(p=>({
            ...p,
            rejectDialog: false,
            rejectNote: ''
        }))
    }

    const handleConfirmReport = async () => {

        try {
            setState((p) => ({
                ...p,
                l: true,
            }));
            await setDocumentStatus(hash, 4, state.rejectNote)
            
            setState((p) => ({
                ...p,
                data: {
                    ...p.data,
                    note: state.rejectNote,
                    status: 'REJECTED'
                },
                l: false,
            }));
            handleClose()
        } catch (e) {
            setState((p) => ({
                ...p,
                l: false,
            }));
            console.error(e);
        }
    }

    const handleChange = (e) => {
        e.persist();
        e.stopPropagation();
        e.preventDefault();
        const { value } = e.target;

        setState((p) => ({
            ...p,
            rejectNote: value
        }));
    }

    return <Dialog open={state.rejectDialog} onClose={handleClose}>
        <DialogContent className={cl.dialogContent}>
            <Typography variant="h6">Скасування</Typography>
            {<TextField
                label="Нотатка"
                variant="outlined"
                size="small"
                fullWidth
                multiline
                minRows={5}
                margin="normal"
                value={state.rejectNote}
                placeholder="причина відмови"
                onChange={handleChange}
            />}
            <Button
                variant="contained"
                color="primary"
                style={{ marginTop: '16px',alignSelf: 'flex-end' }}
                onClick={handleConfirmReport}
                disabled={!state.rejectNote}
            >
                Надіслати
            </Button>
            {state.l && <CircularProgress style={{margin: '0px auto'}}/>}
        </DialogContent>
    </Dialog>
}

export default RejectDialog;
